import { render, staticRenderFns } from "./ViewNewProject.vue?vue&type=template&id=45486fc7&scoped=true&"
import script from "./ViewNewProject.vue?vue&type=script&lang=ts&"
export * from "./ViewNewProject.vue?vue&type=script&lang=ts&"
import style0 from "./ViewNewProject.vue?vue&type=style&index=0&id=45486fc7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45486fc7",
  null
  
)

export default component.exports